import {StepNumber} from '@codev/helix-react';
import React from 'react';
import translations from './translations.js';

const Step1 = ({
  language = 'en_US',
}) => (
  <StepNumber number={1}>
    {translations('step1Text1', language)}
    <br/>
    {translations('step1Text2', language)}
  </StepNumber>
);

export default Step1;